import { TCustomerID } from 'modules/settings/models';
import API from 'services/api';

export const deactivateUser = ({
  userId,
  payload,
}: {
  userId: number | string | null;
  payload: TCustomerID;
}) => {
  return API.post(`/api/users/${userId}/deactivate`, payload);
};
